import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import '../css/components/MainProjects.css';
import DataMainProjects from '../data/DataMainProjects';

function MainProjects() {
  return (
    <section id="projects" className="carousel-projects">
      <h1
        className="page-header"
      >
      Projetos
      </h1>
      <div className="carousel-images">
        {
          DataMainProjects.map((project, index) => {
            return (
              <Card
                key={ index }
                nameProject={ project.nameProject }
                gifImage={ project.gifImage }
                descriptionProject={ project.descriptionProject }
                linkProject={ project.linkProject }
              />
            )
          })
        }
      </div>
      <div
        className="carousel-full-list-projects"
      >
        <Link
          to="/projects"
        >
          <div
            className="carousel-full-list-projects-button"          
          >
            Lista completa dos projetos
          </div>
        </Link>
      </div>
    </section>
  )
}

export default MainProjects;
